import React, { useState, useEffect } from 'react';
import { Input, Select, Button, Form, Modal, Card, Table, Row, Col, Tooltip, Checkbox } from 'antd';
import styles from './FindingTypeTemplate.module.scss';
import { connect } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import { FindingTypeTemplateType, saveFindingTypeTemplate, showModal } from './findingTypeTemplate.slice';
import { IconType } from '../../../shared/models/iconType.enum';
import { FindingTypePropertyTemplateType, fetchFindingTypePropertyTemplates } from '../FindingTypePropertyTemplate/findingTypePropertyTemplate.slice';
import { ToastAnt } from '../../Shared/Toast/ToastAnt';
import { FindingTypePropertyTable } from './FindingTypePropertyTable';
type Props = {
  loading: boolean;
  onFindingTypeTemplateSave: (findingTypeTemplate: FindingTypeTemplateType) => void;
  onShowModal: (visible: boolean) => void;
  findingTypeTemplate: FindingTypeTemplateType;
  findingTypePropertyTemplates: Array<FindingTypePropertyTemplateType>;
  onFindingTypePropertyTemplateInit: () => void;
};

const FindingTypeTemplate = ({
  onFindingTypeTemplateSave,
  onShowModal,
  findingTypeTemplate,
  findingTypePropertyTemplates,
  onFindingTypePropertyTemplateInit
}: Props) => {
  const initialPropertiesToAdd: Array<FindingTypePropertyTemplateType> = [];
  const [propertiesToAdd, setPropertiesToAdd] = useState(initialPropertiesToAdd);
  const initialProperties: Array<FindingTypePropertyTemplateType> = [];
  const [properties, setProperties] = useState(initialProperties);
  const initialPropertiesToRemove: Array<string> = [];
  const [propertiesToRemove, setPropertiesToRemove] = useState(initialPropertiesToRemove);
  const [description, setDescription] = useState('');
  const [color, setColor] = useState('');
  const [id, setId] = useState('');
  const [isMLRelated, setIsMLRelated] = useState(false);
  const [selectedPropertyId, selectPropertyToAdd] = useState<string>();
  const { Option } = Select;

  const [form] = Form.useForm();

  useEffect(() => {
    onFindingTypePropertyTemplateInit();
  }, []);

  useEffect(() => {
    if (findingTypeTemplate) {
      form.setFieldsValue({
        name: findingTypeTemplate.name
      });
      setId(findingTypeTemplate.id!);
      setDescription(findingTypeTemplate.description);
      form.setFieldsValue({ version: findingTypeTemplate.version });
      setColor(findingTypeTemplate.color);
      setIsMLRelated(findingTypeTemplate.isMLRelated);
      if (findingTypePropertyTemplates && findingTypePropertyTemplates.length > 0 && findingTypeTemplate.properties) {
        const propertyTemplates: Array<FindingTypePropertyTemplateType> = [];
        findingTypeTemplate.properties.forEach(element => {
          const propertyTemplate = findingTypePropertyTemplates.filter(x => x.id === element.templateId);
          if (propertyTemplate) {
            propertyTemplates.push({ ...propertyTemplate[0], propertyId: element.id });
          }
        });
        setProperties(propertyTemplates);
      }
      //setPropertiesToAdd(initialPropertiesToAdd);
      setPropertiesToRemove(initialPropertiesToRemove);
    }
  }, [findingTypeTemplate, findingTypePropertyTemplates, form]);

  const handleSubmit = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();

    try {
      var result = await form.validateFields();

      const newItem: FindingTypeTemplateType = {
        id: id,
        name: form.getFieldValue('name')?.trim(),
        version: form.getFieldValue('version'),
        description: description,
        icon: form.getFieldValue('icon'),
        color: color,
        propertyIdsToRemove: propertiesToRemove,
        propertyTemplateIdsToAdd: properties.map(x => x.id!),
        properties: [],
        propertyIds: [],
        findingTypeIds: [],
        canDelete: false,
        isMLRelated: isMLRelated
      };
      onFindingTypeTemplateSave(newItem);
      onShowModal(false);
    } catch (error) {}
  };

  const addProperty = () => {
    if (properties.findIndex(x => x.id === selectedPropertyId) !== -1) {
      ToastAnt('Property already added.');
    } else {
      const selectedProperty = findingTypePropertyTemplates.filter(x => x.id === selectedPropertyId);
      if (selectedProperty && selectedProperty.length > 0) {
        //setPropertiesToAdd([...propertiesToAdd, selectedProperty[0]]);
        setProperties([...properties, selectedProperty[0]]);
        setPropertiesToRemove(propertiesToRemove.filter(x => x !== selectedPropertyId));
      }
    }
  };

  const onRemoveProperty = (selectedPropertyTemplateId: string, selectedPropertyId: string) => {
    //setPropertiesToAdd(propertiesToAdd.filter(x => x.id !== selectedPropertyTemplateId));
    setProperties(properties.filter(x => x.id !== selectedPropertyTemplateId));
    if (selectedPropertyId !== null && selectedPropertyId !== undefined) {
      setPropertiesToRemove([...propertiesToRemove, selectedPropertyId]);
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 8 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 16 },
      sm: { span: 16 }
    }
  };

  const icons = [];
  for (const icon in IconType) {
    if (typeof IconType[icon] === 'number') {
      icons.push(
        <Option key={icon} value={icon}>
          {icon}
        </Option>
      );
    }
  }

  const propertyList: any[] = [];
  findingTypePropertyTemplates.forEach(propertyTemplate => {
    propertyList.push(
      <Option key={propertyTemplate.id} value={propertyTemplate.id!}>
        <Tooltip title={propertyTemplate.fullName} placement='top'>
          <div style={{ width: '100%' }}>
            <div
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              }}
            >
              {propertyTemplate.fullName}
            </div>
          </div>
        </Tooltip>
      </Option>
    );
  });

  const columns = [
    {
      title: 'Name',
      dataIndex: 'fullName',
      key: 'fullName'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => (
        <span>
          <a onClick={() => onRemoveProperty(record.id, record.propertyId)}>Remove</a>
        </span>
      )
    }
  ];

  return (
    <Modal
      title={findingTypeTemplate ? 'Update finding type template' : 'Add new finding type template'}
      visible={true}
      onCancel={() => onShowModal(false)}
      footer={[
        <Button key='save' onClick={e => handleSubmit(e)}>
          Save
        </Button>,
        <Button key='back' onClick={() => onShowModal(false)}>
          Cancel
        </Button>
      ]}
    >
      <Form {...formItemLayout} layout='vertical' form={form}>
        <Form.Item
          label='Finding Type Name'
          name='name'
          className={styles.antFormItem}
          rules={[{ required: true, message: 'Enter finding type name', whitespace: true }]}
        >
          <Input placeholder='Enter finding type name' />
        </Form.Item>
        <Form.Item label='Version' className={styles.antFormItem} rules={[{ required: true, message: 'Enter version' }]} name='version'>
          <Input placeholder='Enter version' />
        </Form.Item>
        <Form.Item label='Description' className={styles.antFormItem}>
          <Input.TextArea
            placeholder='Enter finding type description'
            value={description}
            onChange={e => {
              setDescription(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item
          name='icon'
          label='Finding Type Icon'
          className={styles.antFormItem}
          initialValue={findingTypeTemplate ? IconType[findingTypeTemplate.icon!] : ''}
        >
          <Select placeholder='Select icon type'>{icons}</Select>
        </Form.Item>
        <Form.Item label='Icon Color' className={styles.antFormItem}>
          <Input
            placeholder='Enter color'
            value={color}
            onChange={e => {
              setColor(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label='Is ML related' className={styles.antFormItem}>
          <Checkbox checked={isMLRelated} onChange={e => setIsMLRelated(e.target.checked)} />
        </Form.Item>
        <Card title='Properties'>
          <Row gutter={16}>
            <Col span={16}>
              <Select style={{ minWidth: '250px', maxWidth: '300px' }} onChange={value => selectPropertyToAdd(value.toString())}>
                {propertyList}
              </Select>
            </Col>
            <Col span={8} style={{ textAlign: 'end' }}>
              <Button style={{ marginLeft: 'auto' }} className={styles.addProperty} onClick={() => addProperty()}>
                Add Property
              </Button>
            </Col>
          </Row>
          <FindingTypePropertyTable columns={columns} dataSource={properties} setDataSource={setProperties} rowKey='id' />
        </Card>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  findingTypePropertyTemplates: state.findingTypePropertyTemplate.findingTypePropertyTemplates,
  findingTypeTemplate: state.findingTypeTemplate.selectedFindingTypeTemplate
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onFindingTypeTemplateSave: (findingTypeTemplate: FindingTypeTemplateType) => dispatch(saveFindingTypeTemplate(findingTypeTemplate)),
  onShowModal: (value: boolean) => dispatch(showModal(value)),
  onFindingTypePropertyTemplateInit: () => dispatch(fetchFindingTypePropertyTemplates())
});

export default connect(mapStateToProps, mapDispatchToProps)(FindingTypeTemplate);
